<template>
  <div class="container client">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>项目</el-breadcrumb-item>
        <el-breadcrumb-item>分销推广</el-breadcrumb-item>
        <el-breadcrumb-item>推广订单</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">推广订单</h2>
        </div>
      </div>
    </div>
    <div class="filters card">
      <el-form
        class="search-wrap"
        ref="searchForm"
        :inline="true"
        :model="query"
      >
        <el-form-item
          label="订单号"
          prop="order_no"
        >
          <el-input
            v-model.trim="query.order_no"
            placeholder="输入订单编号"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="商品名称"
          prop="goods_name"
        >
          <el-input
            v-model.trim="query.goods_name"
            placeholder="输入商品名称"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="订单状态"
          prop="status"
        >
          <el-select
            v-model="query.status"
            multiple
            collapse-tags
            placeholder="请选择"
            clearable
            @change="fetchList(true)"
          >
            <el-option
              v-for="item in filter.status"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="用户"
          prop="name"
        >
          <el-input
            v-model="query.user_keyword"
            placeholder="输入用户ID/姓名/手机号"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="推广员"
          prop="name"
        >
          <el-input
            v-model="query.referrer_keyword"
            placeholder="输入推广员ID/姓名"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item
          label="邀请人"
          prop="name"
        >
          <el-input
            v-model="query.referrer_parent_keyword"
            placeholder="输入邀请人ID/姓名"
            @input="searchSetTimeout()"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            class="datetime"
            v-model="createDatetime"
            type="datetimerange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            clearable
            @change="timechange"
            :default-time="['00:00:00', '23:59:59']"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
    </div>
    <div class="results card">
      <div class="table-header">
        <h3 class="title">订单列表</h3>
      </div>
      <div class="values">
        <el-table
          class="table"
          :data="results"
          border
          style="width: 100%"
        >
          <el-table-column
            prop="order_id"
            label="订单ID"
            align="center"
            width="80"
          >
          </el-table-column>
          <el-table-column
            prop="order_no"
            label="订单编号"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="goods_name"
            label="商品名称"
            align="center"
            show-overflow-tooltip
            width="300"
          >
            <template slot-scope="scope">
              <div style="text-align:left;">{{scope.row.goods_name}}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="user_nickname"
            label="用户信息"
            align="center"
            width="120"
            show-overflow-tooltip
          >
          </el-table-column>
          <el-table-column
            prop="order_amount"
            label="订单金额"
            align="center"
            width="120"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{scope.row.order_amount}}元
            </template>
          </el-table-column>
          <el-table-column
            label="订单状态"
            width="120"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ statusRender(scope.row) }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="推广员"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.referrer_nickname ||"/" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="推广佣金"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.referrer_amount>0?`${scope.row.referrer_amount}元`:'/'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="邀请人"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.referrer_parent_nickname ||"/" }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="邀请奖励"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.referrer_parent_amount>0?`${scope.row.referrer_parent_amount}元`:'/'}}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="创建时间"
            width="160px"
            align="center"
          >
            <template slot-scope="scope">
              <span>{{
                $moment(scope.row.create_time).format("YYYY.MM.DD HH:mm:ss")
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            width="80"
            align="center"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="text"
                @click="handleToOrderInfo(scope.row, scope.$index)"
              >详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination
          background
          layout="total, prev, pager, next, sizes, jumper"
          :current-page="Number(query.pageIndex)"
          :page-sizes="[10, 20, 50, 100, 500]"
          :page-size="Number(query.pageSize)"
          :total="Number(pageTotal)"
          @size-change="handleSizeChange"
          @current-change="handlePageChange"
        ></el-pagination>
      </div>
    </div>
    <OrderDetail
      :id="orderId"
      :visible="orderDetailDiglog"
      :userContent="userContent"
      @close="orderDetailDiglog = false"
    ></OrderDetail>
  </div>
</template>

<script>


let Timer = null       // 定时器
let TimerTime = 500    // 定时器 等待时长

import { referrerOrderlist } from "@/api/distribution";
import OrderDetail from "@/components/dialog/order/OrderDetail";
export default {
  components: {
    OrderDetail
  },
  data() {
    return {
      query: {
        pageIndex: 1,
        pageSize: localStorage.getItem("pageSize")
          ? Number(localStorage.getItem("pageSize"))
          : 10,
        isPaging: 1,
      },
      pageTotal: 10,
      results: [],
      filter: {
        status: [
          { label: "待支付", value: "0" },
          { label: "已支付", value: "1" },
          { label: "待发货", value: "2" },
          { label: "待收货", value: "3" },
          { label: "已完成", value: "4" },
          { label: "已取消", value: "5" },
        ],
      },
      userContent: {},
      orderId: null,
      orderDetailDiglog: false,
      createDatetime: "",
    };
  },
  created() {
    this.fetchList()
  },
  watch: {
    // 时间数据监听
    createDatetime(value) {
      if (value) {
        this.query.startTime = this.$moment(value[0]).valueOf();
        this.query.endTime = this.$moment(value[1]).valueOf();
      } else {
        this.query.startTime = "";
        this.query.endTime = "";
      }
    },
  },
  methods: {
    fetchList(isReset = false) {
      if (isReset) {
        this.$set(this.query, "pageIndex", 1);
      }
      const params = Object.assign({}, this.query);
      if (params.status) {
        params.status = params.status.filter((v) => v).join(",");
      }
      referrerOrderlist(params).then((res) => {
        this.results = res.list || [];
        this.pageTotal = res.count;
      });
      this.syncQuery();
    },
    // 分页条数变化
    handleSizeChange(val) {
      this.$set(this.query, "pageSize", val);
      localStorage.setItem("pageSize", val);
      this.fetchList();
    },
    // 分页导航
    handlePageChange(val) {
      this.$set(this.query, "pageIndex", val);
      this.fetchList();
    },
    // 触发搜索按钮
    handleSearch() {
      this.$set(this.query, "pageIndex", 1);
      this.fetchList();
    },
    // 重置搜索条件
    handleFormReset(formName) {
      this.$refs[formName].resetFields();
      this.fetchList();
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key];
      });
      if (this.query.status) {
        this.query.status = this.query.status.split(",");
      }
      if (this.query.startTime && this.query.endTime) {
        this.createDatetime = [
          this.$moment(Number(this.query.startTime)),
          this.$moment(Number(this.query.endTime)),
        ];
      }
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query);
      if (params.status) {
        params.status = params.status.filter((v) => v).join(",");
      }
      let isSync = Object.keys(this.query).some(
        (key) => this.$route.query[key] != this.query[key]
      );
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, this.query),
        });
    },
    // 订单状态渲染
    statusRender(row) {
      const order_status = {
        0: "待支付",
        1: "已支付",
        2: "待发货",
        3: "待收货",
        4: "已完成",
        5: "已取消",
      };
      return order_status[row.status] || "";
    },
    // 订单详情
    handleToOrderInfo(row) {
      this.userContent = JSON.parse(JSON.stringify(row)).user
      this.orderId = row.order_id
      this.orderDetailDiglog = true;
    },
    searchSetTimeout() {
      clearTimeout(Timer)
      Timer = setTimeout(() => {
        this.fetchList(true)
      }, TimerTime)
    },
    timechange(e) {
      if (e == null) {
        this.query.startTime = "";
        this.query.endTime = "";
      }
      this.fetchList(true);
    },
  },
};
</script>

<style scoped lang="less">
.client {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
    padding: 20px;
  }

  .table-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;

      .button {
        // font-size: 14px;
        // padding: 12px 20px;
      }
    }
  }

  .filters {
    margin-top: 10px;

    .search-wrap {
      margin-bottom: -18px;

      .datetime {
        width: 380px;
      }
    }
    .divider {
      border-bottom: 1px dashed #dcdfe6;
      margin: 15px 0;
    }
    .action-wrap {
      display: flex;
      justify-content: flex-end;
    }
  }
  .results {
    flex: 1;
    margin-top: 10px;

    .title {
      font-size: 20px;
      font-weight: bold;
      margin-bottom: 20px;
    }
    .values {
    }
    .footer {
      display: flex;
      justify-content: center;
      margin-top: 20px;
    }
  }
}
.el-link {
  font-size: 12px;
  margin: 0px 5px;
}
</style>
